module.exports = __webpack_public_path__ + "img/T1B_rc_16.be6a606e.png";